import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BenefitRegistration } from '../../../models/benefits.model';

@Component({
	selector: 'app-benefit-modal',
	styles: [
		`
			.item {
				height: 40px;
				border: 1px solid #d9d9d9;
				&:hover {
					background-color: #f0f0f0;
				}
			}
			.gray {
				color: #626262;
			}
			.mb-fix {
				margin-bottom: 84px;
			}
		`,
	],
	templateUrl: './benefit-modal.component.html',
})
export class BenefitModalComponent {
	constructor(
		public dialogRef: MatDialogRef<BenefitModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			benefits: BenefitRegistration[];
			type: 'conjugated' | 'dental' | 'health';
		},
	) {}

	closeModal() {
		this.dialogRef.close();
	}
}
